import React from "react";
import { useNavigate } from "react-router-dom";
import {
  IconCaretDown,
  IconUserCog,
  IconShieldLock,
  IconListDetails,
  IconPower,
} from "@tabler/icons-react";
import { useAuth } from "../../Auth/AuthProvider";
import ProfilePic from "../ProfilePic/ProfilePic";
import { routes } from "../../routes";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/Components/ui/dropdown-menu";

/**
 * @param {{ onNavigate?: () => void }} props
 */
export default function UserMenu({ onNavigate }) {
  const { displayName, email, logout } = useAuth();
  const navigate = useNavigate();

  const go = (path) => {
    onNavigate?.();
    navigate(path);
  };

  const handleLogout = () => {
    onNavigate?.();
    logout().then(() => {
      navigate(routes.home.path);
    });
  };

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        aria-label="User menu"
        className="inline-flex items-center gap-2 text-sm text-mauve-200 outline-none hover:text-white focus-visible:text-white"
      >
        <ProfilePic size={28} />
        <IconCaretDown className="size-3" />
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="min-w-56">
        <DropdownMenuGroup>
          <DropdownMenuLabel className="p-0 font-normal">
            <div className="flex flex-col items-center px-4 py-4">
              <ProfilePic size={64} style={{ marginBottom: 8 }} />
              <div className="text-center">
                <p className="text-sm font-medium text-foreground">
                  {displayName || email}
                </p>
                {displayName && email ? (
                  <p className="text-xs text-muted-foreground">{email}</p>
                ) : null}
              </div>
            </div>
          </DropdownMenuLabel>
        </DropdownMenuGroup>

        <DropdownMenuSeparator />

        <DropdownMenuGroup>
          <DropdownMenuItem onClick={() => go(routes.accountSettings.path)}>
            <IconUserCog />
            Account settings
          </DropdownMenuItem>
        </DropdownMenuGroup>

        <DropdownMenuSeparator />

        <DropdownMenuGroup>
          <DropdownMenuItem onClick={() => go(routes.privacyPolicy.path)}>
            <IconShieldLock />
            Privacy Policy
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => go(routes.termsOfUse.path)}>
            <IconListDetails />
            Terms of use
          </DropdownMenuItem>
        </DropdownMenuGroup>

        <DropdownMenuSeparator />

        <DropdownMenuGroup>
          <DropdownMenuItem onClick={handleLogout}>
            <IconPower />
            Sign out
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
